/* ============
 * Minimal Layout
 * ============
 *
 * Used for the register and login pages
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */

export default {};



// WEBPACK FOOTER //
// ./src/app/layouts/minimal/minimal.js